<div id="content" class="main-content">
    <div class="alert alert-gradient" id="successSave" role="alert" style="opacity: 0;position: fixed;z-index: 100;right: 75px;display: none;"> 
        <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
        <strong>Succes </strong> Visite planifiée  </div>
    <div class="alert alert-gradient alert-danger" id="error" role="alert" style="opacity: 0;position: fixed;z-index: 100;
        display: none;background-image: linear-gradient(135deg,#8f3038ed 0,#e6000cc4 100%) !important;"> 
        <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
        <strong>Echouée</strong> Erreur lors de la planification de la visite</div>
    <div class="notification-shape shape-box " id="notification-corner-expand-shape" data-path-to="m 0,0 500,0 0,500 -500,0 z">
        <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 500 500" preserveAspectRatio="none">
            <path d="m 0,0 500,0 0,500 0,-500 z"/>
        </svg>
    </div>
    <div class="alert alert-gradient alert-danger" id="errors" role="alert" style="opacity: 0;position: fixed;z-index: 100;right: 15%;
        display: none;background-image: linear-gradient(135deg,#8f3038ed 0,#e6000cc4 100%) !important;"> 
        <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
        <strong>Echouée</strong> La modification n'est pas enregistrée</div>
    <div class="alert alert-gradient" id="successSave2" role="alert" style="opacity: 0;position: fixed;z-index: 100;right: 15%;display: none;"> 
        <i class="flaticon-cancel-12 close ml-3" data-dismiss="alert"></i> 
        <strong>Modification</strong>Enregistrée avec succées</div>  
    <div class="container">
        <div class=" row page-header">
            <div class="page-title">
                <h2><b>Visites</b></h2>
            </div>
            <!-- <div *ngIf="modifyloading" class="cp-spinner cp-skeleton spinner_customers mt-0 ml-2"></div> -->
            <div *ngIf="modifyloading" class="cp-spinner cp-skeleton spinner_customers ml-4 mt-3"></div>
        </div>
        <div class="row">
            <div class="col-xl-3 mb-xl-0 col-lg-6 mb-4 col-md-6 col-sm-6" id="left">
                <i class="flaticon-close hide_planned_filter" style="color: rgb(35, 190, 211);display: none;" (click)="hide_filter('planned')"></i>
                <div class="widget-content-area  data-widgets br-4 plannedVisitsIndicator" (click)="showFiltredVisits('planned')">
                    <div *ngIf="loading_indicator" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 1%;
                                        margin-bottom: 1%;"></div>
                    <div *ngIf="!loading_indicator" class="widget  t-order-widget">
                        <div class="media">
                            <div class="icon ml-2">
                                <i class="flaticon-car" style="background-color: #5ad7ff;color: black;"></i>
                            </div>
                            <div class="media-body text-right">
                                <p class="widget-text mb-0">Planifiée</p>
                                <p class="widget-numeric-value">{{planned}} Visites</p>
                            </div>
                        </div>
                    </div>
                    <img src="assets/img/suivitim_img/click_here.gif" alt="" style="width:40px;float: right;right: 0px;
                                    position: absolute;opacity: 0.5;" class="icon_click_here">
                </div>
            </div>
            <div class="col-xl-3 mb-xl-0 col-lg-6 mb-4 col-md-6 col-sm-6" id="right">
                <i class="flaticon-close hide_started_filter" style="color: #30af8f;display: none;" (click)="hide_filter('started')"></i>
                <div class="widget-content-area  data-widgets br-4 startedVisitsIndicator" (click)="showFiltredVisits('started')">
                    <div *ngIf="loading_indicator" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 1%;
                                        margin-bottom: 1%;"></div>
                    <div *ngIf="!loading_indicator" class="widget  t-customer-widget">
                        <div class="media">
                            <div class="icon ml-2">
                                <i class="flaticon-loading-1"></i>
                            </div>
                            <div class="media-body text-right">
                                <p class="widget-text mb-0">En cours</p>
                                <p class="widget-numeric-value">{{inProgress}} Visites</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-2 mb-xl-0 col-lg-6 mb-4 col-md-6 col-sm-6" id="right">
                <i class="flaticon-close hide_terminated_filter" style="color: #387bbb;display: none;" (click)="hide_filter('terminated')"></i>
                <div class="widget-content-area  data-widgets br-4 terminatedVisitsIndicator" (click)="showFiltredVisits('terminated')">
                    <div *ngIf="loading_indicator" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 1%;
                                        margin-bottom: 1%;"></div>
                    <div *ngIf="!loading_indicator" class="widget  t-customer-widget">
                        <div class="media">
                            <div class="icon ml-2">
                                <i class="flaticon-single-tick" style="background-color: #61a4fd;color: white;" ></i>
                            </div>
                            <div class="media-body text-right">
                                <p class="widget-text mb-0">Effectuée</p>
                                <p class="widget-numeric-value">{{done}} visites</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-2 mb-xl-0 col-lg-6 mb-4 col-md-6 col-sm-6" id="right">
                <i class="flaticon-close hide_reported_filter" style="color: #d65b5b;display: none;" (click)="hide_filter('reported')"></i>
                <div class="widget-content-area  data-widgets br-4 p-3 reportedVisitsIndicator" (click)="showFiltredVisits('reported')">
                    <div *ngIf="loading_indicator" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 1%;
                                        margin-bottom: 1%;"></div>
                    <div *ngIf="!loading_indicator" class="widget  t-customer-widget">
                        <div class="media">
                            <div class="icon ml-2">
                                <i class="flaticon-calendar-1" style="background-color: #e99f9f;color: white;"></i>
                            </div>
                            <div class="media-body text-right">
                                <p class="widget-text mb-0">Reportées</p>
                                <p class="widget-numeric-value mb-0">{{reported}} Visites</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-xl-2 mb-xl-0 col-lg-6 mb-4 col-md-6 col-sm-6" id="right">
                 <i class="flaticon-close hide_canceled_filter" style="color: #a54646;display: none;" (click)="hide_filter('canceled')"></i>
                <div class="widget-content-area data-widgets br-4 p-3 canceledVisitsIndicator" (click)="showFiltredVisits('canceled')">
                    <div *ngIf="loading_indicator" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 1%;
                                        margin-bottom: 1%;"></div>
                    <div *ngIf="!loading_indicator" class="widget  t-customer-widget">
                        <div class="media">
                            <div class="icon ml-2">
                                <i class="flaticon-close" style="background-color: #a54646;color: white;"></i>
                            </div>
                            <div class="media-body text-right">
                                <p class="widget-text mb-0">Annulées</p>
                                <p class="widget-numeric-value mb-0">{{canceled}} Visites</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-4" id="cancel-row" >
            <div class="col-xl-12 col-lg-12 col-sm-12  layout-spacing">
                <div class="statbox widget box box-shadow">
                    <div class="widget-header">
                        <div class="row">       
                        </div>
                    </div>
                    <div class="widget-content widget-content-area">
                        <div *ngIf="plannedLoading" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 20%;position: absolute; z-index: 9;left: 47%;
                            margin-bottom: 20%;"></div>
                        <div *ngIf="loading_visit" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 20%;
                        margin-bottom: 20%;"></div>
                        <div  *ngIf="!loading_visit" class="table-responsive mb-4">
                            <table id="alter_pagination" class="table table-striped table-bordered table-hover" style="width:100%">
                                <thead>
                                    <tr>
                                        <th>Visite</th>
                                        <th>Client/Prospect</th>
                                        <th>Secteur</th>
                                        <th>Date visite</th>
                                        <!-- <th>Adresse postale</th> -->
                                        <th>Ville</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr *ngFor="let client of visit">
                                        <td><a href="visite/detail/it;cr={{client?.visit}}" (click)="MarkAsRead(client?.visit)">
                                            <b class="text-primary">{{client.visit_code}}</b>
                                        </a></td>
                                        <td>
                                            <!-- <a href="javascript:void(0);" data-toggle="modal" data-target="#ficheModal" (click)="retrieveCustomer(client.visit_customer_uuid);"
                                                class="mr-2 action_plan_unique customer" title="Voir détail client">
                                                {{client.visit_customer}} 
                                            </a> -->
                                            <a [attr.href]="'/customer/fromshow;cs='+client.visit_customer_uuid" class="mr-2 action_plan_unique customer" title="Voir détail client">
                                                {{client.visit_customer}}
                                            </a>
                                            <a href="javascript:void(0)" *ngIf="client.visit_status=='Terminée'" 
                                                class="text-primary" (click)="Pdf(client?.visit)">
                                                <i class="flaticon-copy-line"></i>
                                                <span class="mb-1 ml-1" style="font-size:x-small;">Rapport</span>
                                            </a>
                                        </td>
                                        <td>
                                            {{client.customer_sector || '----'}}
                                        </td>
                                        <td><span *ngIf="client.visit_planned_at == null">Non planifiée</span>{{client.visit_planned_at | date: 'dd/MM/yyyy HH:mm'}}</td>
                                        <!-- <td>
                                            <span *ngIf="client.visit_customer_address==null">- - -</span>
                                            {{client.visit_customer_address}}</td> -->
                                        <td>{{client.visit_customer_city}}</td>
                                        <!-- <td>{{client.visit_affected_to}}</td> -->
                                        <td><div class="" id="status">
                                            <span *ngIf="client.visit_status=='Terminée'" style="display: inline-flex;">
                                                <span class="dot dot-success align-self-center mr-2"></span>Effectuée</span>
                                            <span *ngIf="client.visit_status=='En attente de validation'" style="display: inline-flex;">
                                                <span class="dot dot-inprogress align-self-center mr-2" 
                                                    style="background-color: gray !important;font-size: small;"></span>
                                                    En attente de validation</span>
                                            <span *ngIf="client.visit_status=='En cours'" style="display: inline-flex;">
                                                <span class="dot dot-inprogress align-self-center mr-2"></span>En cours</span>
                                            <span *ngIf="client.visit_status=='Reportée'" style="display: inline-flex;">
                                                <span class="dot dot-danger align-self-center mr-2"></span>Reportée</span>
                                            <span *ngIf="client.visit_status=='Planifiée'" style="display: inline-flex;">
                                                <span class="dot dot-planifie align-self-center mr-2"></span>Planifiée</span>
                                            <span *ngIf="client.visit_status=='Créée'" style="display: inline-flex;">
                                                <span class="dot dot-info align-self-center mr-2"></span>Créée</span>
                                            <span *ngIf="client.visit_status=='Annulée'" style="display: inline-flex;">
                                                <span class="dot dot-annule align-self-center mr-2"></span>Annulée</span>
                                            <span *ngIf="client.visit_status=='Brouillon'" style="display: inline-flex;">
                                                <img src="assets/img/suivitim_img/finalisation.gif" style="width: 20px;"> Finalisation ...</span>
                                                <span class="cp-spinner cp-skeleton spinner_customers " style="top: 2px;right: -10px;display: none;" 
                                                    id="loading-{{client.visit}}"></span>
                                        </div></td>
                                        <td id="action-{{client.visit}}">
                                            <a  class="btn btn-gradient-dark btn-rounded mb-4 mr-2" *ngIf="client.visit_status=='Brouillon'"
                                                style="margin: 0px !important;" href="complete-visit/fromSave;cr={{client.visit}}">Modifier</a>
                                            <div style="display: flex; flex-direction: column;">
                                                <button  class="btn btn-gradient-success btn-rounded mb-2 mr-1" *ngIf="client.visit_status=='Reportée'"
                                                    data-toggle="modal" data-target="#planifiermodal"(click)="getTeamid(client)">
                                                        Planifier
                                                </button>

                                                <a class="btn btn-gradient-primary btn-rounded mb-2" *ngIf="client.visit_status!='Brouillon'"
                                                style="margin: 0px !important;padding: 3px 10px;" href="visite/detail/it;cr={{client.visit}}" 
                                                (click)="MarkAsRead(client.visit)">Détails</a>
                                            </div>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>    
            </div>
        </div>
    </div>
    <div id="planifiermodal" class="modal animated fadeInUp custo-fadeInUp" role="dialog">
        <div class="modal-dialog modal-md"> 
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title">Visite de <b>{{fullname_commercial}}</b></h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <form [formGroup]="planifierForm" id="date" class="form-group row mb-4 col-lg-12 col-lg-12 col-md-12 col-sm-12 ml-1" 
                style="width: 100%;">
                    <div class="col-lg-4  col-xl-4 col-md-12 col-sm-12 "><h6 style="margin-top: 10%;">Date de visite</h6></div>
                    <div class="col-lg-8  col-xl-8 col-md-12 col-sm-12 col-12"> 
                        <input type="datetime-local" min="{{mindate|date: 'dd/MM/yyyy'}}" class="form-control" style="border-radius: 18px;"
                        [ngModel]="" name="planned_date" formControlName="planned_date" [ngClass]="{'is-invalid':planifierForm.get('planned_date')?.touched
                                && planifierForm.get('planned_date')?.hasError('invalidDate')}">
                        <div *ngIf="planifierForm.get('planned_date')?.hasError('invalidDate')" class="text-danger">
                            {{ planifierForm.get('planned_date')?.getError('invalidDate') ? 'Choisissez une date à partir d\'aujourd\'hui.' : '' }}
                        </div>
                    </div>
                </form>
                <div *ngIf="loading_indicator" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 10%;
                            margin-bottom: 20%;"></div>
                <div *ngIf="!loading_indicator" class="col-xl-12 col-lg-12 col-sm-12" style="margin-top: 2%;">
                    <div class="col-xl-12 col-lg-12 col-sm-12">
                        <div class=" col-xl-12 col-lg-12 col-sm-12 p-3 border-white rounded bg-light" style="overflow-y:scroll;max-height: 235px;">
                            <h6 style="color: #d14545;">Créneaux pleins</h6>
                            <div style="width: 100%;">
                                <div style="margin-top: 2%;" *ngFor="let creneaux of slots">
                                    <span><i style="color: #d14545;" class="flaticon-danger-4 mr-1"></i>{{creneaux.slot_date | date: 'dd/MM/yyyy - HH:mm '}}
                                    <span>{{creneaux.slot_customer}}</span></span> 
                                </div>
                                <p *ngIf="slots?.length==0">Aucune visite n'est planifiée</p>
                            </div>                 
                        </div>
                        <div class="text-center md-button">
                            <button type="button" class="btn btn-primary btn-rounded mt-3 mb-3 mr-2" (click)="Planifier()" [disabled]="!planifierForm.valid" data-dismiss="modal">Planifier</button>
                            <button type="button" class="btn btn-default btn-rounded mt-3 mb-3 " data-dismiss="modal">Retour</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div id="modifiermodal" class="modal animated fadeInUp custo-fadeInUp" role="dialog">
        <div class="modal-dialog modal-lg">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header border-0">
                    <div class="col-xl-12 mb-xl-0 col-lg-12 mb-4 col-md-12 col-sm-6">
                        <div class="text-center data-widgets br-4">
                            <div class="widget  t-sales-widget">
                                <div class="media">
                                    <div class="icon ml-2">
                                        <i class="fa fa-file-alt" style=" background-color: #859aff; color: white;"></i>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-2">
                                <h4 style="font-weight: bold;">Modification Rapport</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div *ngIf="terminer_plan" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 20%;margin-bottom: 20%;"></div>
                <!-- <div class="row" style="margin-left:2%">
                    <div class="">
                        <div class="media-chat mt-1" style="display: inline-flex !important;">
                            <img class="mr-2 " src="assets/img/LOG.jpg" alt="Generic placeholder image" style="border-radius:50% ;width: 100px;">
                        </div>
                    </div>
                    <div>
                        <div class="mt-2 ml-2">
                            <h5 class="" style="margin-top: 2%;font-weight: bold;">Company A</h5>
                            <p style="font-size: small;margin-top: -15%;">Company A ..</p>
                        </div>
                        <div style="margin-top: -8%;;margin-left: 7%;">
                            <i class="flaticon-hour mr-1"></i><span>10/02/2022</span>
                        </div> 
                    </div>
                </div> -->
            <div  *ngIf="!terminer_plan" >
                <form id="contact_form">
                    <div class="" style="margin-top:5%; text-align: center;">
                        <div class=" col-lg-12 col-md-12">
                            <div class="row mt-2 col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;text-align: left;">
                                <div class="form-group mb-2 row col-lg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 p-0 right_inputs">
                                    <label class="col-lg-3 col-lg-3 col-md-5 col-sm-12 col-xs-12 
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);"> 
                                        <b>Client :</b></label>
                                    <div class="col-lg-9 col-lg-9 col-md-6 col-sm-12 col-12 pr-0 pl-0"> 
                                        <p style="margin-top: 2%;">{{retrieved?.visit_customer}}</p> 
                                    </div>
                                </div>
                                <div class="form-group mb-2 row col-lg-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 right_inputs">
                                    <label class="col-lg-3 col-lg-3 col-md-6 col-sm-12 col-xs-12 
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);">
                                        <b>Secteur:</b></label>
                                    <div class="col-lg-9 col-lg-9 col-md-6 col-sm-12 col-12 pr-0 pl-0"> 
                                            <p style="margin-top: 2%;">{{retrieved?.customer_sector || '----'}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <label class=" col-lg-3 col-lg-3 col-md-5 col-sm-6 col-xs-12 pl-0
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);text-align: left;">
                                        <b>Adresse & Ville :</b></label>
                                    <div class="col-lg-9 col-lg-9 col-md-7 col-sm-6 col-12 pr-0 pl-0" style="text-align: left;"> 
                                        <!-- <p style="margin-top: 1%;">{{retrieved?.visit_customer_address}},{{retrieved?.visit_customer_city}}</p>  -->
                                        <p style="margin-top: 1%;">
                                            <span *ngIf="retrieved?.visit_customer_cities == null || retrieved?.visit_customer_cities.length == 0">---</span>
                                            <span *ngIf="retrieved?.visit_customer_address != null && retrieved?.visit_customer_address != ''"> {{retrieved?.visit_customer_address}},</span> 
                                            <span *ngIf="retrieved?.visit_customer_cities != null">
                                                <ng-container *ngFor="let city of retrieved?.visit_customer_cities; let last = last">
                                                    {{ city.name }}{{ last ? '' : ', ' }}
                                                </ng-container>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <label class=" col-lg-3 col-lg-3 col-md-5 col-sm-6 col-xs-12 pl-0
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);text-align: left;">
                                        <b>Visit topic</b></label>
                                    <div class="col-lg-9 col-lg-9 col-md-7 col-sm-6 col-12 pr-0 pl-0" style="text-align: left;"> 
                                        <p style="margin-top: 1%;"><span *ngIf="retrieved?.visit_topic == null">---</span>{{retrieved?.visit_topic}}</p> 
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <label class=" col-lg-3 col-lg-3 col-md-5 col-sm-6 col-xs-12 pl-0
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);text-align: left;">
                                        <b>Objectif</b></label>
                                    <div class="col-lg-9 col-lg-9 col-md-7 col-sm-6 col-12 pr-0 pl-0" style="text-align: left;"> 
                                        <p style="margin-top: 1%;max-width: 100%;"><span *ngIf="retrieved?.visit_goal == null">---</span>
                                            {{retrieved?.visit_goal}}</p> 
                                    </div>
                                </div>
                            </div>
                            <div class="media table-responsive mt-0">
                                <table id="actions_ofvisit" class="table table-striped table-bordered" style="width:100%">
                                    <thead>
                                        <tr>
                                            <th>Action</th>
                                            <th>Commentaire</th>   
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let action of person">
                                            <td><span *ngIf="action.action_desc == null && action.action_desc == undefined">
                                                ---</span>{{action.action_desc}}</td>
                                            <td>
                                                <textarea class="form-control pl-3 pr-3"  rows="2"
                                                    placeholder="Saisir Commentaire" id={{action.action}}>{{action.action_comment}}</textarea>
                                            </td>  
                                        </tr>
                                    </tbody>
                                </table> 
                            </div>
                        </div>
                        <div class="text-left ml-3" style="color: rgb(22, 22, 22);">
                            <b>Personnes contactées</b>
                        </div>
                        <div class="col-xl-12 col-lg-12 col-sm-12" [formGroup]="terminatedVisitForm">
                            <div class="col-xl-12 col-lg-12 col-sm-12 p-0">
                                <div class=" col-xl-12 col-lg-12 col-sm-12 p-3 border-white rounded bg-gray" style="background-color: #f1eeee;">
                                    <div class="row" style="margin-bottom:3%; margin-top: 2%;margin-left: 0%;">
                                        <div class="row col-lg-6 col-md-12 col-sm-12">
                                            <label class="col-lg-5 col-md-6 col-sm-12 mt-2 h6" style="color: black; white-space: nowrap ;font-size: 14px;" 
                                            >Nom complet <span style="color: red;">*</span></label>     
                                            <input type="text" class="form-control  col-lg-7 col-md-6 col-sm-12 form-control-rounded" 
                                            placeholder="Saisir la personne contacté" aria-label="default"  id="input" style="font-size: 11.5px;height:calc(1.5em + .75rem + 2px) !important;"
                                            name="contact_fullname" formControlName="contact_fullname" [ngClass]="{'is-invalid':terminatedVisitForm.get('contact_fullname')?.touched
                                            && terminatedVisitForm.get('contact_fullname')?.invalid}"> 	
                                            <div style="margin-left: auto;" *ngIf="terminatedVisitForm.get('contact_fullname')?.errors?.required"  class="invalid-feedback col-lg-8 col-md-6 col-sm-12"> 
                                                Ce champs est obligatoire
                                            </div>
                                        </div>
                                        <div class="row col-lg-6 col-md-12 col-sm-12">
                                            <label class="col-lg-5 col-md-6 col-sm-12 mt-2 h6" style="color: black; white-space: nowrap;font-size: 14px;"
                                            >Fonction</label>     
                                            <input type="text" class="form-control col-lg-7 col-md-6 col-sm-12 form-control-rounded"
                                            placeholder="Saisir la fonction" aria-label="default" id="input1" style="font-size: 11.5px;height:calc(1.5em + .75rem + 2px) !important;"    
                                            name="contact_function" formControlName="contact_function" [ngClass]="{'is-invalid':terminatedVisitForm.get('contact_function')?.touched
                                            && terminatedVisitForm.get('contact_function')?.invalid}">
                                            <div style="margin-left: auto;" *ngIf="terminatedVisitForm.get('contact_function')?.errors?.required"  class="invalid-feedback"> 
                                                Ce champs est obligatoire
                                            </div>
                                        </div>
                                    </div>
                                    <div class="row" style="margin-bottom:3%; margin-top: 2%;margin-left: 0%;">
                                        <div class="row col-lg-6 col-md-12 col-sm-12">
                                            <label class="col-lg-5 col-md-6 col-sm-12 mt-2 h6" style="color: black; white-space: nowrap ;font-size: 14px;" 
                                            >Nº Téléphone</label>     
                                            <input type="text" class="form-control  col-lg-7 col-md-6 col-sm-12 form-control-rounded" 
                                            placeholder="Saisir le N°Téléphone" aria-label="default"  id="input" style="font-size: 11.5px;height:calc(1.5em + .75rem + 2px) !important;"
                                            name="contact_phone" formControlName="contact_phone" [ngClass]="{'is-invalid':terminatedVisitForm.get('contact_phone')?.touched
                                            && terminatedVisitForm.get('contact_phone')?.invalid}"> 
                                            <div style="margin-left: auto;" *ngIf="terminatedVisitForm.get('contact_phone')?.errors?.required"  class="invalid-feedback col-lg-8 col-md-6 col-sm-12"> 
                                                Ce champs est obligatoire 
                                            </div>
                                            <div style="margin-left: auto;" *ngIf="terminatedVisitForm.get('contact_phone')?.errors?.pattern"  class="invalid-feedback col-lg-8 col-md-6 col-sm-12"> 
                                                Numero invalid
                                            </div>		
                                        </div>
                                        <div class="row col-lg-6 col-md-12 col-sm-12">
                                            <label class="col-lg-5 col-md-6 col-sm-12 mt-2 h6" style="color: black; white-space: nowrap;font-size: 14px;"
                                            >Email</label>     
                                            <input type="text" class="form-control col-lg-7 col-md-6 col-sm-12 form-control-rounded"
                                            placeholder="Saisir l'Email" aria-label="default" id="input1" style="font-size: 11.5px;height:calc(1.5em + .75rem + 2px) !important;"    
                                            name="contact_email" formControlName="contact_email" [ngClass]="{'is-invalid':terminatedVisitForm.get('contact_email')?.touched
                                            && terminatedVisitForm.get('contact_email')?.invalid}">
                                            <div style="margin-left: auto;" *ngIf="terminatedVisitForm.get('contact_email')?.errors?.required"  class="invalid-feedback col-lg-8 col-md-6 col-sm-12"> 
                                                Ce champs est obligatoire 
                                            </div>
                                            <div style="margin-left: auto;" *ngIf="terminatedVisitForm.get('contact_email')?.errors?.email"  class="invalid-feedback col-lg-8 col-md-6 col-sm-12"> 
                                            Adresse mail invalid
                                            </div>
                                        </div>
                                    </div>
                                    <div class="mt-0 text-right col-lg-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <button class="btn btn-primary btn-rounded mt-0 mb-0 pt-1 pb-1" (click)="addDetailToFinish()" 
                                            [disabled]="!terminatedVisitForm.valid || noSells">Ajouter</button>
                                    </div>
                                    <div class="media table-responsive mt-3" *ngIf="sells.length !=0">
                                        <table class="table table-striped table-bordered">
                                            <thead style="background-color: #cac0ff6b;">
                                                <tr>
                                                    <th>Nom complet</th>
                                                    <th>Fonction</th>
                                                    <th>Nº Téléphone</th>
                                                    <th>Email</th>  
                                                    <th></th> 
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr *ngFor="let prod of sells" >
                                                    <td class="p-0">{{prod.contact_fullname}}</td>
                                                    <td class="p-0"> 
                                                        {{prod.contact_function}}
                                                    </td>
                                                    <td class="p-0">
                                                        {{prod.contact_phone}}
                                                    </td>
                                                    <td class="p-0">{{prod.contact_email}}</td>
                                                    <td>
                                                        <button type="button" class="btn btn-dark mr-2" (click)="removeDetailToFinish(prod)">
                                                            <i class="flaticon-delete text-white" style="background-color: unset;"></i></button>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </form> 
                <div class="mt-4">
                    <div class="col-lg-12 pt-3 upload__box">
                        <div class="custom-file-container" data-upload-id="myFirstImage">
                            <p class="mb-0" style="display: flex;justify-content: center;"><i class="flaticon-picture text-default mr-2" style="background-color: unset;"></i>Joindre des photos</p>
                            <label class="custom-file-container__custom-file" >
                                <input type="file" class="custom-file-container__custom-file__custom-file-input upload__inputfile" accept="image/*" multiple=""
                                    data-max_length="20" (change)="addPic($event,'terminate')">
                                <input type="hidden" name="MAX_FILE_SIZE" value="10485760" />
                                <span class="custom-file-container__custom-file__custom-file-control"></span>
                            </label>
                            <div class="upload__img-wrap"></div>
                        </div>
                    </div>
                    <div class=" row col-lg-12 col-xl-12 md-button">
                        <div class="text-center col-lg-2 col-xl-2">
                            <button type="button" class="btn btn-default btn-rounded mt-3 mb-3 " data-dismiss="modal">Retour</button>
                        </div>
                        <div class="text-center col-lg-6 col-xl-6">
                            <button type="button" style="background-color: lightblue;" class="btn btn-default btn-rounded mt-3 mb-3 " data-dismiss="modal"
                            (click)="modifyrepport('save')">Enregistrer comme brouillon</button>
                        </div>
                        <div class="text-center col-lg-4 col-xl-4">
                            <button type="button" class="btn btn-primary btn-rounded mt-3 mb-3 " data-dismiss="modal"
                             (click)="modifyrepport('finish')" [disabled]="sells.length == 0">Marquer comme terminée</button>
                        </div>
                    </div>
                </div>
            </div>
           
        </div>
    </div>
    </div>
    <div id="historymodal" class="modal animated fadeInUp custo-fadeInUp" role="dialog">
        <div class="modal-dialog modal-xl">
            <!-- Modal content-->
            <div class="modal-content">
                <div class="modal-header">
                    <h4 class="modal-title"> <b>Historique des actions</b></h4>
                    <button type="button" class="close" data-dismiss="modal">&times;</button>
                </div>
                <div class="modal-body">
                    <div class="statbox widget box box-shadow">
                        <div class="widget-content widget-content-area area_popin">
                            <div class="media table-responsive">
                                <!-- <div *ngIf="loading_actions" class="cp-spinner cp-bubble" style="margin: auto;display: block;margin-top: 20%;
                                margin-bottom: 20%;"></div> -->
                                <table id="alter_paginations" class="table table-striped table-bordered" style="width:100%">
                                    
                                    <thead >
                                        <tr>
                                            <th>Commercial</th>
                                            <th>Action</th>
                                            <th>Client</th>
                                            <th>Date action</th>
                                            <th>Ajoutée par</th>
                                            <th>Date d'ajout</th>
                                            <th>Status action</th> 
                                            <th>Status Visite</th>     
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr *ngFor="let history of action" >
                                            <td>{{history.action_added_by}}</td>
                                            <td>{{history.action_description}}</td>
                                            <td>{{history.action_added_to_customer}}</td>
                                            <td>
                                                <span *ngIf="history.action_added_at == null">---</span>
                                                {{history.action_added_at | date: 'dd/MM/yyyy - HH:mm '}}
                                            </td>
                                            <td>{{history.action_added_by}}</td>
                                            <td>
                                                <span *ngIf="history.action_added_at == null">---</span>
                                                {{history.action_added_at | date: 'dd/MM/yyyy - HH:mm '}}
                                            </td>
                                            <td>
                                                <div class="text-center">
                                                    <b>
                                                        <span *ngIf="history.action_status=='Fait'" class="text-success">{{history.action_status}}</span>
                                                        <span *ngIf="history.action_status=='En cours'" class="text-primary">{{history.action_status}}</span>
                                                        <span *ngIf="history.action_status=='Non fait'" class="text-warning">{{history.action_status}}</span>
                                                        <span *ngIf="history.action_status=='- - -'" class="text-danger">{{history.action_status}}</span>
                                                    </b>
                                                </div>
                                            </td>
                                            <td>
                                                <div id="status" class="text-center">
                                                    <span *ngIf="history.visit_action_status=='Terminée'" style="display: inline-flex;">
                                                        <span class="dot dot-success align-self-center mr-2"></span>Effectuée</span>
                                                    <span *ngIf="history.visit_action_status=='En attente de validation'" style="display: inline-flex;">
                                                        <span class="dot dot-inprogress align-self-center mr-2" 
                                                            style="background-color: gray !important;font-size: small;"></span>
                                                            En attente de validation</span>
                                                    <span *ngIf="history.visit_action_status=='En cours'" style="display: inline-flex;">
                                                        <span class="dot dot-inprogress align-self-center mr-2"></span>En cours</span>
                                                    <span *ngIf="history.visit_action_status=='Reportée'" style="display: inline-flex;">
                                                        <span class="dot dot-danger align-self-center mr-2"></span>Reportée</span>
                                                    <span *ngIf="history.visit_action_status=='Planifiée'" style="display: inline-flex;">
                                                        <span class="dot dot-planifie align-self-center mr-2"></span>Planifiée</span>
                                                    <span *ngIf="history.visit_action_status=='Créée'" style="display: inline-flex;">
                                                        <span class="dot dot-info align-self-center mr-2"></span>Créée</span>
                                                    <span *ngIf="history.visit_action_status=='Annulée'" style="display: inline-flex;">
                                                        <span class="dot dot-annule align-self-center mr-2"></span>Annulée</span>
                                                    <span *ngIf="history.visit_action_status=='Brouillon'" style="display: inline-flex;">
                                                        <img src="assets/img/suivitim_img/finalisation.gif" style="width: 20px;height: 20px;border: unset;">
                                                            Finalisation ...</span>
                                                </div>
                                            </td>  
                                        </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="text-center md-button">
                    <button type="button" class="btn btn-default btn-rounded mt-3 mb-3 " data-dismiss="modal">Retour</button>
                </div>
            </div>
        </div>
    </div>
<!--  Fiche Client Modal -->
<div id="ficheModal" class="modal animated rotateInDownLeft custo-rotateInDownLeft show text-center"  tabindex="-1" role="dialog" aria-labelledby="exampleSuccessAlertLabel">
    <div class="modal-dialog modal-xl " role="document">
        <div class="modal-content">
        <div class="modal-body">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
            <div class="">
                <i class="flaticon-building-1 mt-5"></i>
                <h4 class="modal-title mt-4 mb-4 rs_customer" id="exampleSuccessAlertLabel">
                    <b *ngIf="!retrieveCustomerLoder">{{selectedCustomer?.customer_rs}}</b>
                </h4>
            </div>
            <div class="row align-items-end">
                <div class="col-lg">
                    <div *ngIf="retrieveCustomerLoder" class="cp-spinner cp-skeleton spinner_messages"></div> 

                    <form id="contact_form" *ngIf="!retrieveCustomerLoder">
                        <div class=" col-lg-12 col-md-12">
                            <div class="row mt-2 col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;text-align: left;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 p-0 right_inputs">
                                    <label class="col-lg-6 col-md-6 col-sm-12 col-xs-12 
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);"> 
                                        <b>Secteur :</b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0"> 
                                        <p style="margin-top: 2%;margin-left: 5%;">{{selectedCustomer?.customer_sector}}</p> 
                                    </div>
                                </div>
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 right_inputs">
                                    <label class="col-lg-6 col-md-6 col-sm-12 col-xs-12 
                                        col-form-label col-form-label-sm pl-0" style="color: rgb(22, 22, 22);">
                                        <b>Représentant:</b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0"> 
                                            <p style="margin-top: 2%;"> <span *ngIf="selectedCustomer?.customer_agent == null">---</span>{{selectedCustomer?.customer_agent}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <label class=" col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);text-align: left;">
                                        <b>Adresse & Ville :</b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0" style="text-align: left;"> 
                                        <!-- <p style="margin-top: 1%;">
                                            <span *ngIf="selectedCustomer?.customer_address == null">---</span>
                                            {{selectedCustomer?.customer_address}},{{selectedCustomer?.customer_city}}
                                        </p>  -->
                                        <p style="margin-top: 1%;">
                                            <span *ngIf="selectedCustomer?.customer_cities == null || selectedCustomer?.customer_cities.length == 0">---</span>
                                            <span *ngIf="selectedCustomer?.customer_address != null && selectedCustomer?.customer_address != ''"> {{selectedCustomer?.visit_customer_address}},</span> 
                                            <span *ngIf="selectedCustomer?.customer_cities != null">
                                                <ng-container *ngFor="let city of selectedCustomer?.customer_cities; let last = last">
                                                    {{ city.name }}{{ last ? '' : ', ' }}
                                                </ng-container>
                                            </span>
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <label class=" col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);text-align: left;">
                                        <b>N° Téléphone : </b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0" style="text-align: left;"> 
                                        <p style="margin-top: 1%;"><span *ngIf="selectedCustomer?.customer_phone == null || selectedCustomer?.customer_phone == ''">---</span>{{selectedCustomer?.customer_phone}}</p> 
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <label class=" col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);text-align: left;">
                                        <b>N° Skype : </b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0" style="text-align: left;"> 
                                        <p style="margin-top: 1%;max-width: 100%;"><span *ngIf="selectedCustomer?.customer_skype == null || selectedCustomer?.customer_skype == ''">---</span>
                                            {{selectedCustomer?.customer_skype}}</p> 
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <label class=" col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);text-align: left;">
                                        <b>Classe : </b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0" style="text-align: left;"> 
                                        <p style="margin-top: 1%;max-width: 100%;">
                                            <span *ngIf="selectedCustomer?.customerClass == null">---</span>
                                            <b *ngIf="selectedCustomer?.customerClass != null " [ngClass]="{'text-success': selectedCustomer?.customerClass?.refClass == 'Classe A', 
                                            'text-secondary': selectedCustomer?.customerClass?.refClass == 'Classe B',
                                            'text-warning': selectedCustomer?.customerClass?.refClass == 'Classe C',
                                            'text-dark': selectedCustomer?.customerClass?.refClass == 'Classe D' }">
                                                {{selectedCustomer?.customerClass?.refClass}}
                                            </b>
                                        </p> 
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <label class=" col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);text-align: left;">
                                        <b>Ajouté le : </b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0" style="text-align: left;"> 
                                        <p style="margin-top: 1%;max-width: 100%;">
                                            <span *ngIf="selectedCustomer?.customer_added_at == null">---</span>
                                            {{selectedCustomer?.customer_added_at | date: 'dd-MM-yyyy'}}
                                        </p> 
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-12 col-md-12 pr-0 pl-0" style="display: inline-flex;">
                                <div class="form-group mb-2 row col-lg-12 col-md-12 col-sm-12 col-xs-12 ">
                                    <label class=" col-lg-6 col-md-6 col-sm-12 col-xs-12 pl-0
                                        col-form-label col-form-label-sm" style="color: rgb(22, 22, 22);text-align: left;">
                                        <b>Commercial : </b></label>
                                    <div class="col-lg-6 col-md-6 col-sm-12 col-12 pr-0 pl-0" style="text-align: left;"> 
                                        <p style="margin-top: 1%;max-width: 100%;">
                                            <span *ngIf="!selectedCustomer?.commercials[0]?.commercial">---</span>
                                            {{selectedCustomer?.commercials[0]?.commercial | titlecase}}
                                        </p> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="col-lg">
                    <!-- MESSAGES -->
                    <div>
                        <h4 class="text-primary mb-1" style="margin-left: 2%;color: rgb(22, 22, 22)">Conversation</h4>
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <div class="mail-chat-system">
                                <div class="chat_window">
                                    <div *ngIf="loadingMessages" class="cp-spinner cp-skeleton spinner_messages"></div> 
                                    <p *ngIf="messages?.length==0 && !loadingMessages" class="text-center" style="color:gray;">Aucun message pour ce Client</p>
                                    <ul class="chat-messages pl-0 pt-5" *ngIf="messages.length>0">
                                        <!-- <span *ngFor="let message of messages"> -->
                                        <div class="message appeared" style="top: 10%;" *ngFor="let message of messages; let i=index; let last = last"
                                            [ngStyle]="{'margin-top': i>0 ? '70px' : '0px'}"
                                            [ngClass]="{'right': message.sender == 'me', 'left': message.sender != 'me' }">
                                            <div class="avatar" 
                                                [ngStyle]="{'background-image': message.sender_avatar == null ? 'url(../assets/img/me.jpg)' : 'url(data:image/jpg;base64,'+message.sender_avatar+ ')' }"
                                                > </div>
                                            <div class="text_wrapper">
                                                <div class="text mt-7 mb-7" [ngClass]="{'urgent_msg': message.important,' ': !message.important}">{{message.message}}
                                                    <p class="text-left mb-0 mt-4" style="font-size: smaller;"
                                                    [ngClass]="{'text-dark': message.sender == 'me', 'text-default': message.sender != 'me' }">
                                                        <b>{{message?.sent_at | date: 'dd/MM/yyyy - HH:mm '}}</b>
                                                    </p>
                                                    <span *ngIf="message.important && last" class="text-right" style="font-size: smaller;">
                                                        <img src="assets/img/suivitim_img/important.gif" *ngIf="message.sender == 'me'" style="width: 20px;height: 20px;border: unset;">
                                                        <img src="assets/img/suivitim_img/important_other.gif" *ngIf="message.sender != 'me'" style="width: 20px;height: 20px;border: unset;">
                                                            <b> En attente de réponse !</b></span>
                                                </div>
                                            </div>
                                            <span class="mb-2 ml-2 badge badge-pills outline-badge-primary seeAt mt-1" 
                                                *ngIf="message.sender == 'me' && message.seen">
                                                {{message?.see_at | date: 'dd/MM/yyyy - HH:mm '}} <img src="assets/img/suivitim_img/commentSeen.gif"
                                                style="width: 20px;height: 20px;border: unset;"></span>
                                        </div>
                                    </ul>
                                    <div class="chat-bottom-section mt-3 clearfix">
                                        <div class="input-group mb-2 message_input_wrapper">
                                            <div class="input-group-prepend" id="msg_urgent">
                                                
                                            </div>
                                            <input type="text" class="message_input form-control" id="messageText" style="border-radius: 10px;"
                                                placeholder="Saisir votre message ...">
                                            <div class="input-group-append ml-0">
                                                <button class="input-group-text br-0" (click)="sendNewMessage(selectedCustomer?.customer)">Envoyer 
                                                    <i *ngIf="!sending" class="flaticon-send-fill-1"></i>
                                                    <img *ngIf="sending" src="../../../assets/img/envoyer-message-enveloppe.gif" alt="" width="25px">
                                                </button>
                                            </div>
                                            
                                            
                                        </div>
                                        <div class="custom-control rounded-chk custom-checkbox checkbox-primary">
                                            <input type="checkbox" class="custom-control-input" id="roundedChk2" checked="">
                                            <label class="custom-control-label" for="roundedChk2">J'attends la réponse</label>
                                        </div>
                                            
                                    </div>
                                </div>
                                <div class="message_template d-none">
                                    <div class="message">
                                        <div class="avatar"></div>
                                        <div class="text_wrapper">
                                            <div class="text"></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>  
            <button type="button" class="btn btn-gradient-default btn-rounded mt-3 mb-4" data-dismiss="modal">Retour</button>
        </div>
        </div>
    </div>
</div>